import {
  CONTENT_DOMAINS,
  CONTENT_GOVERNANCE_ROLES,
  CONTENT_PUBLICATION_POLICY,
  CONTENT_STAGES,
  type ContentDomain,
} from "./forfeoContentGovernanceContract.ts";

export const CONTENT_GOVERNANCE_CONSOLE_MODE = "READ_ONLY_LOCAL_FOUNDATION" as const;

export const CONTENT_GOVERNANCE_CONSOLE_SECTIONS = (
  Object.entries(CONTENT_DOMAINS) as Array<[
    ContentDomain,
    (typeof CONTENT_DOMAINS)[ContentDomain],
  ]>
).map(([id, domain]) => ({
  id,
  label: domain.label,
  operationalOwner: domain.operationalOwner,
  financialAuthority: domain.financialAuthority,
  bilingual: domain.requiresBilingualPublication,
  status: "inventory_ready" as const,
}));

export const CONTENT_GOVERNANCE_WORKFLOW = CONTENT_STAGES.map((stage, index) => ({
  stage,
  order: index + 1,
  final: stage === "published" || stage === "archived" || stage === "rejected",
}));

export const CONTENT_GOVERNANCE_ROLE_SUMMARY = Object.values(
  CONTENT_GOVERNANCE_ROLES,
).map(({ permission, actions }) => ({
  permission,
  actionCount: actions.length,
  actions: [...actions],
}));

export const CONTENT_GOVERNANCE_PUBLICATION_CHECKLIST = [
  {
    id: "bilingual",
    label: "Contenu complet en français et en anglais",
    required: CONTENT_PUBLICATION_POLICY.bilingualLocales.length === 2,
  },
  {
    id: "reviewer",
    label: "Révision éditoriale consignée",
    required: CONTENT_PUBLICATION_POLICY.requireReviewer,
  },
  {
    id: "publisher",
    label: "Approbation par un éditeur distinct",
    required: CONTENT_PUBLICATION_POLICY.separationOfDuties,
  },
  {
    id: "audit",
    label: "Piste d’audit disponible",
    required: CONTENT_PUBLICATION_POLICY.requireAuditTrail,
  },
] as const;

export function summarizeContentGovernanceConsole() {
  return {
    mode: CONTENT_GOVERNANCE_CONSOLE_MODE,
    domainCount: CONTENT_GOVERNANCE_CONSOLE_SECTIONS.length,
    bilingualDomainCount: CONTENT_GOVERNANCE_CONSOLE_SECTIONS.filter(
      ({ bilingual }) => bilingual,
    ).length,
    workflowStageCount: CONTENT_GOVERNANCE_WORKFLOW.length,
    roleCount: CONTENT_GOVERNANCE_ROLE_SUMMARY.length,
    publicationChecklistCount: CONTENT_GOVERNANCE_PUBLICATION_CHECKLIST.length,
    browserDirectPublicationAllowed:
      CONTENT_PUBLICATION_POLICY.browserDirectPublicationAllowed,
    browserFinancialMutationAllowed:
      CONTENT_PUBLICATION_POLICY.browserFinancialMutationAllowed,
    financialAuthority: "GIFTSHOP" as const,
  };
}
